<template>
    <div style="margin-top: 12px; padding-bottom: 32px; height: 100px;">
        <swiper style="height: 100%; " :options="swiperOption" role="tablist" ref="swiper">
            <swiper-slide :style="{overflow: overflow}" v-for="each, i in home_banners" :key="i" style="width: 100%; height: 100%; position: relative; border-radius: 12px;" role="tab">
                <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each.image_path" alt="" @click="doAction(each)">
            </swiper-slide>
            <div class="swiper-pagination paging_text" slot="pagination" style="font-size:12px; top: 20px; height: 20px; text-align: right; padding-right: 20px; z-index: 10; display:inline-block;"></div>
        </swiper>
    </div>

</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    name: "SwipedHomeBannerSmall",
    components: { swiper, swiperSlide },
    props: {
        home_banners: {
            type: Array,
            default: () => []
        },
        overflow: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            swiperOption: {
                // slidesPerView: 'auto',
                spaceBetween: 20, // swiper-slide 사이의 간격 지정
                slidesOffsetBefore: 0, // slidesOffsetBefore는 첫번째 슬라이드의 시작점에 대한 변경할 때 사용
                slidesOffsetAfter: 0, // slidesOffsetAfter는 마지막 슬라이드 시작점 + 마지막 슬라이드 너비에 해당하는 위치의 변경이 필요할 때 사용
                freeMode: false, // freeMode를 사용시 스크롤하는 느낌으로 구현 가능
                centerInsufficientSlides: true, // 컨텐츠의 수량에 따라 중앙정렬 여부를 결정함
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets'
                },
                autoplay: {
                    delay: 5000
                },
                curIndex: 0,
            },
        }
    },
    methods: {
        showInterviewDetail(detail) {
            this.$GlobalStore.addModal('InterviewDetail', { spotlightIdx: detail.idx })
        },
        doAction(banner) {
            if (banner.idx === 7) {
                this.$Util.sendEventClick('홈_스포트라이트_배너_상단', true);
            } else if (banner.idx === 6) {
                this.$Util.sendEventClick('홈_축구팀_입단_배너', true)
            }

            console.log();

            window.pushCustomManager.goScreen(null, banner.param1, banner.action, banner.param1);
        }

    }
}
</script>

<style scoped>
.swiper-pagination>>>.swiper-pagination-bullet-active {
    background: #fff
}

.swiper-pagination>>>.swiper-pagination-bullet {
    width: 6px;
    height: 6px;
}
</style>